import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  subscription ExpertIsTyping($chatId: ID!) {
    expertIsTyping(id: $chatId) {
      id
      expertIsTyping
    }
  }
`);
